import React from 'react';
import { PaginationProvider } from './Pagination';

export interface DataGridFooterProps {
  /**
   * Total number of rows
   */
  totalRows: number;
  /**
   * Rows per page
   */
  rowsPerPage: number;
  /**
   * Rows being skipped to display the current page
   */
  rowsToSkip: number;
  /**
   * Page selected specfying number of rows to skip
   */
  onChange: (v: number) => void;
}
export const DataGridFooter: React.FC<DataGridFooterProps> = (props) => {
  return (
    <div className="row">
      <div className="col mt-2">
        Showing rows {props.rowsToSkip + 1} to {Math.min(props.rowsToSkip + props.rowsPerPage, props.totalRows)} of {props.totalRows}
      </div>
      {props.totalRows / props.rowsPerPage > 1 ? (
        <div className="col mt-2 d-flex justify-content-end">
          <PaginationProvider {...props} />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
